/* eslint-disable*/
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import React, { useState, useEffect, Fragment, useRef } from 'react';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import { InputAdornment } from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import { Formik, Form, Field, FastField, FieldArray } from 'formik';
import MaterialTable from 'material-table';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import TableRow from '@material-ui/core/TableRow';
import moment from 'moment';
import KeyboardArrowLeftIcon from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import AddIcon from '@material-ui/icons/Add';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CloseIcon from '@material-ui/icons/Close';
import EditIcon from '@material-ui/icons/Edit';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined';
import CalendarTodayOutlinedIcon from '@material-ui/icons/CalendarTodayOutlined';
import PeopleAltOutlinedIcon from '@material-ui/icons/PeopleAltOutlined';

import {
  Checkbox,
  TextField,
  Box,
  Button,
  Card,
  FormControlLabel,
  FormGroup,
  Step,
  StepLabel,
  Stepper,
  Typography,
  FormControl,
  RadioGroup,
  Radio,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  DialogActions,
  Breadcrumbs,
  Link,
  Divider,
  AppBar,
  Tabs,
  Tab,
  Badge,
  Switch,
  FormHelperText,
  Popover,
} from '@material-ui/core';
import { object, string, ref, date } from 'yup';
import { showErrIfTouched, filterDate } from '../../../../utils';
import useForms from '../../../../hooks/useForms';
import usePractice from '../../../../hooks/usePractice';
import clsx from 'clsx';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

/* CSS */
import useStyles from '../../Main.style';
import './css/calendar.css';
import { forEach, isNull, keys, split } from 'lodash';
import { array } from 'prop-types';
import FilterListIcon from '@material-ui/icons/FilterList';
import Autocomplete from '@material-ui/lab/Autocomplete';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import useCalendarEvents from '../../../../hooks/useCalendarEvents';
import usePermissions from '../../../../hooks/usePermissions';
//import AllEventModal from '../AllEventModal/AllEventModal';
const styles = {
  inputAdornment: {
    position: 'absolute',
    right: '0',
    top: '0',
    bottom: '0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: '1',
    padding: '0 12px',
    pointerEvents: 'none',
  },
};
const Calendar = ({ month, year, preloadedEvents = [], onEditEvent }) => {
  const classes = useStyles();
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));

  const selectedDate = new Date(year, month - 1);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const [date, setDate] = useState(selectedDate);
  const [viewingEvent, setViewingEvent] = useState(false);
  const [showingEventForm, setShowingEventForm] = useState({ visible: false });
  const [allEventModal, setAllEventModal] = useState({ visible: false });
  const [isLoading, setIsLoading] = useState(false);
  const [feedback, setFeedback] = useState();
  const [notificationRole, setNotificationRole] = useState('');
  const [eventToDelete, setEventToDelete] = useState(null);
  const [eventType, setEventType] = useState('');
  const [addCalendarPermission, setAddCalendarPermission] = useState(false);
  const [editCalendarPermission, setEditCalendarPermission] = useState(false);
  const [deleteCalendarPermission, setDeleteCalendarPermission] = useState(false);
  const [loggedInUserDetails, setLoggedInUserDetails] = useState([]);

  const {
    addEvent,
    updateSelectedEvent,
    getCalendarEventsByuser,
    getCalendarEvents,
    deleteEvent,
    getSingleEvent,
  } = useCalendarEvents();
  const { getPermissionId } = usePermissions();
  const { getUserDetails } = usePractice();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const elementRef = useRef(null);
  let elementWidth = 0;

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleDeleteClose = () => {
    setOpenDeleteDialog(false);
  };
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const notificationPermission = () => {
    if (loggedInUserData.roleId === 1) {
      setNotificationRole('leadership');
    } else if (loggedInUserData.roleId === 0) {
      setNotificationRole('employees');
    } else if (loggedInUserData.roleId === 2) {
      setNotificationRole('alumni');
    }
  };

  const loadPermissions = async () => {
    const userDetail = await getUserDetails(loggedInUserData?.id);
    setLoggedInUserDetails(userDetail?.usersResult?.[0]);
    const add = await getPermissionId('Calendar-Add');

    setAddCalendarPermission(
      userDetail?.usersResult?.[0]?.permissionArray != null
        ? userDetail?.usersResult?.[0]?.permissionArray.indexOf(add?.usersResult?.[0]?.id) !== -1
          ? true
          : false
        : false,
    );

    const edit = await getPermissionId('Calendar-Edit');

    setEditCalendarPermission(
      userDetail?.usersResult?.[0]?.permissionArray != null
        ? userDetail?.usersResult?.[0]?.permissionArray.indexOf(edit.usersResult?.[0].id) !== -1
          ? true
          : false
        : false,
    );

    const remove = await getPermissionId('Calendar-Delete');

    setDeleteCalendarPermission(
      userDetail?.usersResult?.[0]?.permissionArray != null
        ? userDetail?.usersResult?.[0]?.permissionArray?.indexOf(remove?.usersResult?.[0]?.id) !==
          -1
          ? true
          : false
        : false,
    );
  };
  // Could be used to filter out the invalid events data also
  // (ie. missing properties) or events that can't be parsed
  // to contain valid to/from dates
  const parseEvents = (events, _caller) => {
    if (events !== null) {
      return events.map((event) => {
        if (_caller == 'add' || _caller == 'edit') {
          const startOfDay = moment.utc(event.dateFrom).startOf('day');
          const dateFromIsoString = startOfDay.toISOString();
          event.dateFrom = dateFromIsoString;

          const endOfDay = moment.utc(event.dateFrom).endOf('day');
          const dateToIsoString = endOfDay.toISOString();
          event.dateTo = dateToIsoString;
        }

        // else {
        //   event.dateFrom = moment(new Date(event.dateFrom).setUTCHours(0, 0, 0, 0)).toISOString();
        // }

        return {
          ...event,
        };
      });
    }
  };

  const parsedEvents = parseEvents(preloadedEvents, 'add');
  const [events, setEvents] = useState(preloadedEvents);
  const [openDeleteDialog, setOpenDeleteDialog] = React.useState(false);
  const MOCK_LOADING_TIME = 0;

  useEffect(() => {
    if (preloadedEvents != null) {
      if (parsedEvents) {
        setEvents(parsedEvents);
      }
    }
  }, [preloadedEvents]);

  useEffect(() => {
    notificationPermission();
  }, [loggedInUserData]);

  useEffect(() => {
    loadPermissions();
  }, []);

  useEffect(() => {
    if (elementRef.current) {
      elementWidth = elementRef.current.offsetWidth;
    }
  }, []);

  // Utilities/helpers
  const MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  const DAYS_SHORT = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  const toStartOfDay = (date) => {
    const newDate = new Date(date);
    newDate.setHours(0);
    newDate.setMinutes(0);
    newDate.setSeconds(0);
    newDate.setMilliseconds(0);
    return newDate;
  };

  const pad = (input) => {
    return input < 10 ? '0' + input : input;
  };

  // I'm using default <input type="datepick-local">,
  // so a specific date format is required
  const dateToInputFormat = (date) => {
    if (!date) {
      return null;
    }

    // const month = pad(date.getMonth() + 1);
    // const day = pad(date.getDate());
    // const hours = pad(date.getHours());
    // const minutes = pad(date.getMinutes());

    // return `${date.getFullYear()}-${month}-${day}T${hours}:${minutes}`;
  };

  const findEventsForDate = (events, date) => {
    const dateTime = date.getTime();
    return events.filter((event) => {
      const eventFromTime = moment(toStartOfDay(event.dateFrom).getTime());
      const eventToTime = moment(toStartOfDay(event.dateTo).getTime());
      return dateTime >= eventFromTime && dateTime < eventToTime;
    });
  };

  // Top bar, contains the month/year combo as well as back/forward links
  const Navigation = ({ date, setDate, setShowingEventForm }) => {
    return (
      <div className="navigation">
        <div>
          <div className="monthAndYear">
            {MONTHS[date.getMonth()]} {date.getFullYear()}
          </div>

          <div className="Todaybtn">
            <Button
              variant="outlined"
              onClick={() => {
                const newDate = new Date();
                newDate.setMonth(newDate.getMonth());
                setDate(newDate);
              }}
              color="primary"
              href="javascript:;"
            >
              Today
            </Button>
          </div>

          <div
            className="back"
            onClick={() => {
              const newDate = new Date(date);
              newDate.setMonth(newDate.getMonth() - 1);
              setDate(newDate);
            }}
          >
            {
              <IconButton>
                <KeyboardArrowLeftIcon color="primary" />
              </IconButton>
            }{' '}
            {/* {MONTHS[date.getMonth() == 0 ? 11 : date.getMonth() - 1]} */}
          </div>

          <div
            className="forward"
            onClick={() => {
              const newDate = new Date(date);
              newDate.setMonth(newDate.getMonth() + 1);
              setDate(newDate);
            }}
          >
            {/* {MONTHS[date.getMonth() == 11 ? 0 : date.getMonth() + 1]} */}{' '}
            {
              <IconButton>
                <KeyboardArrowRightIcon color="primary" />
              </IconButton>
            }
          </div>
        </div>

        <div>
          <If condition={addCalendarPermission == true}>
            <Button
              startIcon={<AddIcon />}
              variant="contained"
              color="primary"
              href="javascript:;"
              onClick={() => {
                setShowingEventForm({ visible: true });
                //setIsButtonDisabled(true);
                setEventType('add');
              }}
            >
              Add Event
            </Button>
          </If>

          {/* <a href="javascript:;" onClick={() => setShowingEventForm({ visible: true })}>
            +
          </a> */}
        </div>
      </div>
    );
  };

  // Week day headers: Mon, Tue, Wed etc
  const DayLabels = () => {
    return DAYS_SHORT.map((dayLabel, index) => {
      return (
        <div className="dayLabel cell" key={index}>
          {dayLabel}
        </div>
      );
    });
  };

  // An individual event displayed within the calendar grid itself
  // can be clicked to open the main event view
  const MiniEvent = ({ event, setViewingEvent }) => {
    return (
      <div
        className={`miniEvent ${
          event.receivers && event.receivers.toLowerCase() == 'leadership'
            ? event.receivers.toLowerCase()
            : 'standard'
        }`}
        onClick={() => {
          setViewingEvent(event);
          setAnchorEl(null);
        }}
      >
        {event.receivers && event.receivers.toLowerCase() == 'leadership' ? (
          <>
            <img
              className="leaderImg"
              src={require('../../../../assets/images/Calendar-VGL-icon.png').default}
              alt="Specialty"
            />
          </>
        ) : (
          <FiberManualRecordIcon />
        )}

        {event.name}
      </div>
    );
  };

  // The main event view, opens in a modal and contains all information
  // about the event in question
  function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  const Event = ({ event, setViewingEvent, setShowingEventForm, deleteEventModal }) => {
    return (
      <Modal onClose={() => setViewingEvent(null)} title={<b></b>} className="eventModal">
        <Box className="iconouter">
          <If condition={loggedInUserData?.id == event?.createdByUser}>
            <Box>
              <a
                href="javascript:;"
                onClick={() => {
                  setViewingEvent(null);
                  setShowingEventForm({ visible: true, withEvent: event });
                  setEventType('edit');
                }}
              >
                <IconButton>
                  <EditIcon color="primary" />
                </IconButton>
              </a>
            </Box>
          </If>
          <If condition={loggedInUserData?.id == event?.createdByUser}>
            <Box>
              <a
                href="javascript:;"
                onClick={() => {
                  setViewingEvent(null);
                  setOpenDeleteDialog(true);
                  setEventToDelete(event);
                  //deleteEventModal(event);
                }}
              >
                <IconButton>
                  <DeleteOutlineIcon color="primary" />
                </IconButton>
              </a>
            </Box>
          </If>

          <Box borderLeft={1} style={{ borderColor: 'rgba(15, 15, 16, 0.1)' }}>
            <a href="javascript:;" onClick={() => setViewingEvent(null)}>
              <IconButton>
                <CloseIcon color="primary" />
              </IconButton>
            </a>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" mt={3}>
          <Box display="flex" mr={2}>
            <img src={require('../../../../assets/images/vg-logo.png').default} alt="Specialty" />
          </Box>
          <Box>
            <h2>{event.name}</h2>
          </Box>
        </Box>
        <Box display="flex" alignItems="center" mt={3}>
          <Box display="flex" justifyContent="center" width="32px" mr={2}>
            {<CalendarTodayOutlinedIcon />}
          </Box>
          {moment(event.dateFrom).format('dddd, MMMM Do')}
        </Box>
        <Box display="flex" alignItems="center" mt={3}>
          <Box display="flex" justifyContent="center" width="32px" mr={2}>
            {<PeopleAltOutlinedIcon />}
          </Box>
          {capitalizeFirstLetter(event.receivers)}
        </Box>
        <Box display="flex" alignItems="center" mt={3}>
          <Box display="flex" justifyContent="center" width="32px" mr={2}>
            {<DescriptionOutlinedIcon />}
          </Box>
          {event.description || 'No description added'}
        </Box>
      </Modal>
    );
  };

  // Form to add new events or edit existing events
  // In a real implementation, we'd have some frontend
  // validation and also the equivalent in our
  // backend service...
  const maxDate = new Date();
  maxDate.setFullYear(maxDate.getFullYear() + 10);

  // Utility function to format a date object as mm-dd-yyyy
  const formatDateToInput = (date) => {
    if (!date) return '';
    return moment.utc(date).format('MM-DD-YYYY');
  };

  const EventForm = ({
    setShowingEventForm,
    addEventModal,
    editEvent,
    withEvent,
    setViewingEvent,
    preselectedDate,
  }) => {
    const newEvent = withEvent || {};

    if (!withEvent && !!preselectedDate) {
      newEvent.dateFrom = dateToInputFormat(preselectedDate);
    }

    const [event, setEvent] = useState(newEvent);
    const [validationMessage, setValidationMessage] = useState('');
    const [validationMessageDesc, setValidationMessageDesc] = useState('');
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);

    let isTitleEmpty = false;
    let isTitleTooShort = false;
    let isTitleTooLong = false;
    let isTitleInvalid = false;

    let isTitleEmptyDesc = false;
    let isTitleTooShortDesc = false;
    let isTitleTooLongDesc = false;
    let isTitleInvalidDesc = false;

    let eventNameInput = '';
    let eventDescriptionInput = '';

    const [enteredDate, setEnteredDate] = useState(event.dateFrom || new Date());
    useEffect(() => {
      eventNameInput = document.getElementById('event-title').value;
      setEvent({ ...event, name: eventNameInput });
      eventDescriptionInput = document.getElementById('event-desc').value;
      setEvent({ ...event, description: eventDescriptionInput });
      checkValidationName();
      checkValidationDesc();
    }, [event.name, event.description, event.dateFrom, eventType, enteredDate]);

    const checkValidationName = () => {
      if ('name' in event && event.name.length === 0) {
        // Required field validation
        isTitleEmpty = Object.keys(event).length == 0 || event.name.trim() === '';
      } else if (!('name' in event)) {
        isTitleEmpty = true;
      } else if ('name' in event && event.name.length > 0) {
        // Length validation
        isTitleTooShort = event.name.length < 3;
        isTitleTooLong = event.name.length > 50;
        // Format validation
        isTitleInvalid = !/^[a-zA-Z0-9\s]+$/.test(event.name);
      }
      // Combine all validation messages
      const validationMessages = [
        eventType === 'add' ? '' : isTitleEmpty ? '* Please enter an event name.' : '',
        isTitleTooShort || isTitleTooLong ? 'Event name must be between 3 and 50 characters.' : '',
        isTitleInvalid ? 'Event name must contain only letters, numbers, and spaces.' : '',
      ];

      // Set the validation message
      setValidationMessage(validationMessages.filter(Boolean).join(' '));
      setIsButtonDisabled(
        isTitleEmpty ||
          isTitleTooShort ||
          isTitleTooLong ||
          isTitleInvalid ||
          isTitleEmptyDesc ||
          isTitleTooShortDesc ||
          isTitleTooLongDesc ||
          isTitleInvalidDesc,
      );
    };
    const checkValidationDesc = () => {
      if ('description' in event && event.description.length === 0) {
        // Required field validation
        isTitleEmptyDesc = Object.keys(event).length == 0 || event.description.trim() === '';
      } else if ('description' in event && event.description.length > 0) {
        // Length validation

        isTitleTooShortDesc = event.description.length < 3;
        isTitleTooLongDesc = event.description.length > 250;

        // Format validation
        isTitleInvalidDesc = !/^[a-zA-Z0-9\s]+$/.test(event.description);
      }
      // Combine all validation messages
      const validationMessages = [
        eventType === 'add' ? '' : isTitleEmptyDesc ? '* Please enter event desciption.' : '',
        isTitleTooShortDesc || isTitleTooLongDesc
          ? 'Event desciption must be between 3 and 250 characters.'
          : '',
        isTitleInvalidDesc
          ? 'Event desciption must contain only letters, numbers, and spaces.'
          : '',
      ];

      // Set the validation message
      setValidationMessageDesc(validationMessages.filter(Boolean).join(' '));
      setIsButtonDisabled(
        isTitleEmpty ||
          isTitleTooShort ||
          isTitleTooLong ||
          isTitleInvalid ||
          isTitleEmptyDesc ||
          isTitleTooShortDesc ||
          isTitleTooLongDesc ||
          isTitleInvalidDesc,
      );
    };

    return (
      <Modal
        className="addnewevent"
        onClose={() => setShowingEventForm({ visible: false })}
        title={`${withEvent ? 'Edit event' : 'Add a new event'}`}
      >
        <a
          className="closebtn"
          href="javascript:;"
          onClick={() => {
            setEventType('');
            setShowingEventForm({ visible: false });
          }}
        >
          <IconButton>
            <CloseIcon color="primary" />
          </IconButton>
        </a>
        <div className="form">
          <label>
            <input
              type="text"
              id="event-title"
              placeholder="Add Event Name"
              defaultValue={event.name}
              onBlur={() => {
                checkValidationName();
                checkValidationDesc();
              }}
              onChange={(e) => {
                setEvent({ ...event, name: e.target.value });
                checkValidationName();
                checkValidationDesc();
              }}
            />
            <div className="error">{validationMessage}</div>
          </label>

          <label>
            Select Date*<br></br>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              <KeyboardDatePicker
                className="CustomKeyboardDatePicker"
                required
                disableToolbar
                variant="outline"
                format="MM/dd/yyyy"
                margin="normal"
                id="event-date"
                label=""
                autoOk
                value={enteredDate}
                minDate={new Date()}
                maxDate={maxDate}
                onChange={(date) => {
                  if (date === null || date === undefined) {
                    setEnteredDate(new Date());
                    setEvent({ ...event, dateFrom: new Date() });
                  } else {
                    setEnteredDate(date);
                    setEvent({ ...event, dateFrom: date });
                  }
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date',
                }}
                style={{ width: '100%' }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" style={styles.inputAdornment}>
                      <IconButton>
                        <CalendarTodayIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </MuiPickersUtilsProvider>
            {/* <input
              type="date"
              min={getMinDate().toISOString().split('T')[0]}
              max={getMaxDate().toISOString().split('T')[0]}
              defaultValue={
                event.dateFrom
                  ? dateToInputFormat(new Date(event.dateFrom))
                  : dateToInputFormat(new Date()) // use moment to format date
              }
              onChange={(e) => {
                const enteredDate = moment(e.target.value, 'YYYY-MM-DD');
                if (enteredDate.isValid()) {
                  const formattedDate = enteredDate.format('MM/DD/YYYY');
                  setEvent({ ...event, dateFrom: formattedDate });
                }
              }}
            /> */}
          </label>
          {/* 
          <label>
            Date to
            <input
              type="date"
              defaultValue={event.dateTo}
              onChange={(e) => setEvent({ ...event, dateTo: e.target.value })}
            />
          </label> */}

          <label>
            Select Calendar(s) to Include on*
            <select
              id="selReceivers"
              value={event.receivers && event.receivers}
              onChange={(e) => setEvent({ ...event, receivers: e.target.value })}
            >
              <option selected="selected" value="Employees">
                Employees
              </option>
              <option value="Leadership">Leadership</option>
              <option value="All">All</option>
            </select>
          </label>

          <label>
            Event Description*
            <textarea
              type="text"
              id="event-desc"
              placeholder="Add description"
              defaultValue={event.description}
              onBlur={() => {
                checkValidationName();
                checkValidationDesc();
              }}
              onChange={(e) => {
                setEvent({ ...event, description: e.target.value });
                checkValidationName();
                checkValidationDesc();
              }}
            ></textarea>
            <div className="error">{validationMessageDesc}</div>
          </label>

          {withEvent ? (
            <Fragment>
              <Box mt={3} display="flex" justifyContent="right">
                <Button
                  disabled={isButtonDisabled}
                  variant="contained"
                  color="primary"
                  onClick={() => editEvent(event)}
                >
                  Edit event
                </Button>
              </Box>
            </Fragment>
          ) : (
            <Fragment>
              <Box mt={3} display="flex" justifyContent="right">
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    const receiversValue = document
                      .getElementById('selReceivers')
                      .value.toLowerCase();

                    if (event?.receivers === undefined) {
                      event['receivers'] = receiversValue;
                    }

                    addEventModal(event);
                  }}
                  disabled={isButtonDisabled}
                >
                  Add Event
                </Button>
              </Box>
            </Fragment>
          )}
        </div>
      </Modal>
    );
  };

  // Generic component - modal to present children within
  const Modal = ({ children, onClose, title, className }) => {
    return (
      <Fragment>
        <div className="overlay" onClick={onClose} />
        <div className={`modal ${className}`}>
          <h3>{title}</h3>
          <div className="inner">{children}</div>
        </div>
      </Fragment>
    );
  };

  const DeleteConfirmation = ({ eventToDelete }) => {
    return (
      <>
        {' '}
        <Dialog
          className={classes.dialogOuterMedium}
          fullScreen={fullScreen}
          open={openDeleteDialog}
          onClose={handleDeleteClose}
          aria-labelledby="responsive-dialog-title"
          eventToDelete={eventToDelete}
        >
          <DialogTitle className={classes.dialogTitle} id="responsive-dialog-title">
            <Typography variant="h2" noWrap component="span">
              {`Are you sure you want to delete?`}
            </Typography>
            <IconButton aria-label="close" onClick={handleDeleteClose}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent></DialogContent>
          <DialogActions>
            <Button
              onClick={() => {
                deleteEventModal(eventToDelete);
              }}
              color="primary"
              variant="contained"
            >
              Yes
            </Button>
            <Button
              onClick={handleDeleteClose}
              className={classes.secondaryBtnUI}
              variant="outlined"
              color="secondary"
              autoFocus
            >
              No
            </Button>
          </DialogActions>
        </Dialog>
        ;
      </>
    );
  };

  const AllEventModal = () => {
    return (
      <>
        <Popover
          id={id}
          anchorReference="anchorPosition"
          open={open}
          anchorPosition={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          ref={elementRef}
        >
          <Box className="allevent" p={2}>
            <Box display="flex" justifyContent="space-between" mb={1}>
              <Box display="flex" alignItems="center">
                <Box display="flex" mr={1}>
                  <img
                    src={require('../../../../assets/images/event-calendar.png').default}
                    alt="Event Calendar"
                    width="20px"
                  />
                </Box>
                <Box>
                  <h4>{moment(allEventModal.events[0].dateFrom).format('dddd, MMMM Do')}</h4>
                </Box>
              </Box>

              <a
                className="closebtn"
                href="javascript:;"
                onClick={() => setAllEventModal({ visible: false })}
              >
                <IconButton>
                  <CloseIcon color="secondary" />
                </IconButton>
              </a>
            </Box>
            {allEventModal.events.map((e, index) => {
              return (
                <>
                  <div className="alleventlistitem">
                    <MiniEvent key={index} event={e} setViewingEvent={setViewingEvent} />
                    {/* {<FiberManualRecordIcon />} {e.name} */}
                  </div>
                </>
              );
            })}
          </Box>
        </Popover>

        {/* <Modal className="allevent"></Modal> */}
      </>
    );
  };
  //Generic component - a nicely animated loading spinner
  const Loader = () => {
    return (
      <Fragment>
        <div className="overlay" />
        <div className="loader">
          <div className="lds-roller">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      </Fragment>
    );
  };

  // Generic component - simple feedback after an action has taken place
  const Feedback = ({ message, type }) => {
    return <div className={`feedback ${type}`}>{message}</div>;
  };

  // The grid of days, renders a month's worth of days and
  // also populates the events on the relevant dates
  const Grid = ({ date, events, setViewingEvent, setShowingEventForm, actualDate }) => {
    const ROWS_COUNT = 6;
    const currentDate = toStartOfDay(new Date());

    // Finds the closest Monday relative to the first day of
    // the target month/year combination
    // Then increment upon this day until we have a full set
    // of date objects to work with
    const startingDate = new Date(date.getFullYear(), date.getMonth(), 1);
    startingDate.setDate(startingDate.getDate() - (startingDate.getDay() - 1));

    const dates = [];
    for (let i = 0; i < ROWS_COUNT * 7; i++) {
      const date = new Date(startingDate);
      dates.push({ date, events: findEventsForDate(events, date) });

      startingDate.setDate(startingDate.getDate() + 1);
    }

    return (
      <Fragment>
        {dates.map((date, index) => {
          return (
            <div
              key={index}
              className={`cell ${date.date.getTime() == currentDate.getTime() ? 'current' : ''} ${
                date.date.getMonth() != actualDate.getMonth() ? 'otherMonth' : ''
              }`}
            >
              <div className="date">{date.date.getDate()}</div>

              {date.events.map((event, index) => {
                if (index < 2) {
                  return (
                    (event?.receivers.toLowerCase() == 'all' ||
                      event?.receivers.toLowerCase() == notificationRole ||
                      loggedInUserData?.department?.departmentTitle === 'Superadmin' ||
                      loggedInUserData?.department?.departmentTitle === 'HR') && (
                      <>
                        <MiniEvent key={index} event={event} setViewingEvent={setViewingEvent} />
                      </>
                    )
                  );
                }
              })}
              {date.events.length > 2 && (
                <div
                  className="moreevent"
                  onClick={async (event) => {
                    setAnchorEl({
                      top: event.clientY,
                      left: event.clientX,
                    });
                    // should log the first element in the HTMLCollection

                    return setAllEventModal({ visible: true, events: date.events });
                  }}
                >
                  {<>+ {date.events.length - 2} more</>}
                </div>
              )}
            </div>
          );
        })}
      </Fragment>
    );
  };
  useEffect(() => {
    console.log("Date has changed... Let's load some fresh data...");
  }, [date]);

  const addEventModal = async (event) => {
    setIsLoading(true);
    setShowingEventForm({ visible: false });
    event.createdByUser = loggedInUserData?.id;
    event.cellId = loggedInUserData?.cellId;
    event.countryId = loggedInUserData?.countryId;
    event.departmentId = loggedInUserData?.departmentId;

    // These timeouts are to imitate HTTP requests
    // So in a real impementation, you'd interact
    // with your backend service here and handle
    // the result accordingly...
    // Likewise for `editEvent` and `deleteEvent`
    // below
    // setTimeout(async () => {

    const parsedEvents = parseEvents([event], 'add');

    const updatedEvents = [...events];
    const result = await addEvent(parsedEvents[0]);

    if (typeof result !== 'undefined') {
      if (result.status) {
        updatedEvents.push(result.userDataResult);

        setEvents(updatedEvents);
        setIsLoading(false);
        showFeedback({ message: 'Event created successfully', type: 'success' });
      }
    }
    // }, MOCK_LOADING_TIME);
  };

  const editEvent = async (event) => {
    setIsLoading(true);
    setShowingEventForm({ visible: false });

    // setTimeout(async () => {
    const parsedEvent = parseEvents([event], 'edit');

    const updatedEvents = [...events].map((updatedEvent) => {
      return updatedEvent.id === event.id ? parsedEvent[0] : updatedEvent;
    });

    const result = await updateSelectedEvent(
      updatedEvents.find((object) => object.id === event.id),
    );

    if (typeof result !== 'undefined') {
      if (result.status) {
        setEvents(updatedEvents);
        onEditEvent(updatedEvents);
        setIsLoading(false);
        showFeedback({ message: 'Event edited successfully', type: 'success' });
      }
    }
    // }, MOCK_LOADING_TIME);
  };

  const deleteEventModal = async (event) => {
    setIsLoading(true);
    setViewingEvent(null);

    const updatedEvents = [...events].filter((finalEvent) => finalEvent.id != event.id);

    const result = await deleteEvent(event.id);

    if (typeof result !== 'undefined') {
      setEvents(updatedEvents);
      onEditEvent(updatedEvents);
      setIsLoading(false);
      setOpenDeleteDialog(false);
      showFeedback({ message: 'Event deleted successfully', type: 'success' });
    }
    // }, MOCK_LOADING_TIME);
  };

  const showFeedback = ({ message, type, timeout = 2500 }) => {
    setFeedback({ message, type });
    setTimeout(() => {
      setFeedback(null);
    }, timeout);
  };

  return (
    <>
      <div class="calendarTitle">
        <h1>Company Calendar Notification</h1>
      </div>
      <Navigation date={date} setDate={setDate} setShowingEventForm={setShowingEventForm} />
      <div className="calendar">
        {/* {isLoading && <Loader />} */}

        {feedback && <Feedback message={feedback.message} type={feedback.type} />}

        <DayLabels />

        <Grid
          date={date}
          events={events}
          setShowingEventForm={setShowingEventForm}
          setViewingEvent={setViewingEvent}
          actualDate={date}
        />

        {viewingEvent && (
          <Event
            event={viewingEvent}
            setShowingEventForm={setShowingEventForm}
            setViewingEvent={setViewingEvent}
            deleteEventModal={deleteEventModal}
          />
        )}

        {showingEventForm && showingEventForm.visible && (
          <EventForm
            withEvent={showingEventForm.withEvent}
            preselectedDate={showingEventForm.preselectedDate}
            setShowingEventForm={setShowingEventForm}
            addEventModal={addEventModal}
            editEvent={editEvent}
            setViewingEvent={setViewingEvent}
          />
        )}
        {allEventModal && allEventModal.visible && (
          <AllEventModal />

          // <Popover
          //   id={id}
          //   open={open}
          //   anchorEl={anchorEl}
          //   onClose={handleClose}
          //   anchorOrigin={{
          //     vertical: 'bottom',
          //     horizontal: 'left',
          //   }}
          // >
          //   <Typography sx={{ p: 2 }}>The content of the Popover.</Typography>
          // </Popover>
        )}

        <DeleteConfirmation eventToDelete={eventToDelete} />
      </div>
    </>
  );
};

export default Calendar;
